/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {
    window.PXUTheme.jsFeaturedCollection = $.extend(
      this,
      window.PXUTheme.getSectionData($section)
    );

    if (this.collection_layout === 'slider') {
      this.createSlider($section, '.slider-gallery--desktop');
    }

    if (this.collection_layout_mobile === 'slider') {
      this.createSlider($section, '.slider-gallery--mobile');
    }
  },

  createSlider: function($section, selector) {
    const $slider = $section.find(selector);
    if (!$slider.length) return;

    // prevent double init per section
    if ($slider.hasClass('flickity-enabled')) return;

    const self = this;
    const sectionId = $section.attr('id') || Math.random().toString(36).slice(2);

    arrowShape = 'M95 45H15.8l26.9-26.9c1.9-1.9 1.9-5.1 0-7s-5.1-1.9-7 0L3.5 43.3c-3.1 3.1-3.1 8.2 0 11.3l32.2 32.2c1.9 1.9 5.1 1.9 7 0s1.9-5.1 0-7L15.8 53H95c2.8 0 5-2.2 5-5s-2.2-5-5-5z';

    $slider.flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: this.products_limit > this.products_per,
      initialIndex: 0,
      arrowShape: arrowShape
    });

    const flkty = $slider.data('flickity');
    if (!flkty) return;

    // state to avoid jank
    let isDragging = false;
    let rafId = null;
    let timeoutId = null;

    // cache last applied max height to avoid pointless resize()
    $slider.data('pxuLastMaxHeight', 0);

    const scheduleEqualize = () => {
      // cancel any queued run
      if (rafId) cancelAnimationFrame(rafId);
      if (timeoutId) clearTimeout(timeoutId);

      // run after current paint + a tiny delay
      rafId = requestAnimationFrame(() => {
        timeoutId = setTimeout(() => {
          // do not reflow while user is interacting or Flickity is mid-animate
          if (isDragging || flkty.isAnimating) {
            scheduleEqualize(); // try again shortly
            return;
          }

          const changed = self.equalizeCardHeights($slider);

          // only resize if height actually changed
          if (changed) {
            $slider.flickity('resize');
          }
        }, 60);
      });
    };

    // flickity interaction flags
    $slider.on('dragStart.flickity', () => { isDragging = true; });
    $slider.on('dragEnd.flickity', () => { isDragging = false; scheduleEqualize(); });

    // triggers that matter, but are now safe (queued, not immediate)
    $slider.on('ready.flickity', scheduleEqualize);
    $slider.on('imagesLoaded.flickity', scheduleEqualize);
    $slider.on('lazyLoad.flickity', scheduleEqualize);
    $slider.on('settle.flickity', scheduleEqualize);

    // window resize (debounced, per section)
    let resizeTimer;
    $(window).on('resize.jsFeaturedCollection.' + sectionId, function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleEqualize, 200);
    });

    $slider.data('pxuSectionId', sectionId);

    // run once immediately
    scheduleEqualize();
  },

  // returns true if max height changed (so caller can decide whether to resize)
  equalizeCardHeights: function($slider) {
    const $wraps = $slider.find('.gallery-cell .product-wrap');
    if (!$wraps.length) return false;

    // reset so we measure natural heights
    $wraps.css('min-height', '');

    let max = 0;
    $wraps.each(function () {
      const h = $(this).outerHeight(true);
      if (h > max) max = h;
    });

    if (max <= 0) return false;

    const last = $slider.data('pxuLastMaxHeight') || 0;
    if (Math.abs(max - last) < 1) {
      // re-apply anyway (in case DOM swapped) but don't trigger resize
      $wraps.css('min-height', max + 'px');
      return false;
    }

    $slider.data('pxuLastMaxHeight', max);
    $wraps.css('min-height', max + 'px');
    return true;
  },

  unload: function($section) {
    const $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');

    const sectionId = $slider.data('pxuSectionId');
    if (sectionId) {
      $(window).off('resize.jsFeaturedCollection.' + sectionId);
    }
  }
};

/******/ })();
